module.exports = __webpack_public_path__ + "static/media/gms-marker.50b285b5.svg";